





































































































import BaseLoading from '@/components/base/BaseLoading.vue';
import ContentWrapper from '@/components/ContentWrapper.vue';
import {
  UpdateGroupLevelAttributeValueDTO,
  UpdateIndividualGroupLevelAttributeValueDTO
} from '@/jbi-shared/dto/jaas-group-level-attributes.dtos';
import {
  CreateGroupLicenseDTO,
  UpdateGroupDTO
} from '@/jbi-shared/dto/jaas-groups.dtos';
import {
  CourseDetails,
  TrainerResponseDTO,
  UpdateCourseMasterDTO,
  UpdateCourseStatusDTO,
  UpsertCourseModuleDTO,
  UpsertCoursePackageApiDTO
} from '@/jbi-shared/dto/jtms.dtos';
import {
  AttributeOptionsWithValue,
  GroupLevelAttributeValue
} from '@/jbi-shared/types/jaas-group-level-attributes.types';
import {
  CourseModuleStatus,
  CoursePackageStatus,
  CourseStatus,
  CourseVisibility
} from '@/jbi-shared/types/jtms.types';
import {
  MyjbiGroupType,
  MyjbiGroupUserAttributeSpec
} from '@/jbi-shared/types/myjbi-group.types';
import { Debounce } from '@/jbi-shared/util/debounce.vue-decorator';
import { deepCopy } from '@/jbi-shared/util/deep-copy.util';
import { defaultGULAs } from '@/jbi-shared/util/group-user-level-attributes.util';
import { isTruthy } from '@/jbi-shared/util/watcher.vue-decorator';
import BaseMultiSelect from '@/jbi-shared/vue-components/BaseMultiSelect.vue';
import { GroupDetail } from '@/store/modules/admin/types/admin.types';
import { GroupUserAttributeWithValue } from '@/store/modules/admin/types/group-user-attribute.types';
import {
  MasterGroupsResponseDTO,
  RemoveEmailDomainsPayload,
  UpdateGroupRequestPayload,
  UserAttributesStringInputOption
} from '@/store/modules/admin/types/group.types';
import {
  CourseModuleComponentItem,
  DeleteCourseModulesApiDTO
} from '@/store/modules/jtms/course-module/course-module.types';
import { CoursePackageComponent } from '@/store/modules/jtms/course-package/course-package.types';
import {
  CourseCreateAndUpdateButtonEventTypes,
  CourseTabsNames,
  CourseTypeDTO,
  CourseTypeOption,
  TabComponent,
  UpdateCourseTypeApiDTO
} from '@/store/modules/jtms/course/course.types';
import { EntityTypes } from '@/store/modules/module-tree/enums/module-tree.enums';
import {
  PermissionsMatrixActionsEnum,
  ResourceExceptions
} from '@/store/modules/roles-and-permissions/types/roles-and-permissions.types';
import { GetSignedUrlForUploadResponsePayload } from '@/store/modules/static-file/types/static-file.types';
import { RootState } from '@/store/store';
import { ApiAxiosError, ApiState } from '@/store/types/general.types';
import { convertToAttributeOptionsWithValue } from '@/utils/group-level-attribute.util';
import { MemberObject, userAttributesArrWithValues } from '@/utils/group.util';
import { convertCourseModuleComponentItem } from '@/utils/jtms-utils';
import { isUserAllowed } from '@/utils/rbac.util';
import AgreementSection from '@/views/AdminCreateGroup/components/AgreementSection.vue';
import { DialogProgrammatic, ToastProgrammatic as Toast } from 'buefy';
import {
  ValidationObserver,
  ValidationObserverInstance,
  ValidationProvider
} from 'vee-validate';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';
import CourseCreationSubmitButtons from '../CreateCourses/components/CourseCreationSubmitButtons.vue';
import CourseNameAndTypeForm from '../CreateCourses/components/CourseNameAndTypeForm.vue';
import CourseSettingsToggles from '../CreateCourses/components/CourseSettingsToggles.vue';
import CourseLevelAttributeTab from '../CreateCourses/CourseLevelAttributes/CourseLevelAttribute.tab.vue';
import CourseModulesTab from '../CreateCourses/CourseModules/CourseModules.tab.vue';
import CoursePackagesTab from '../CreateCourses/CoursePackages/CoursePackages.tab.vue';
import DisableCourseModulesModal from './components/comfirmation-modals/CourseCancellationConfirmationModal.vue';
import OpenOrCloseRegistrationModal from './components/comfirmation-modals/OpenOrCloseRegistrationModal.vue';
import PublishDraftCourseModal from './components/PublishDraftCourseModal.vue';
import PublishRegistrationStatusSelection from './components/PublishRegistrationStatusSelection.vue';

@Component({
  components: {
    ContentWrapper,
    BaseLoading,
    BaseMultiSelect,
    AgreementSection,
    ValidationObserver,
    ValidationProvider,
    CourseNameAndTypeForm,
    CourseLevelAttributeTab,
    CourseCreationSubmitButtons,
    CourseModulesTab,
    PublishRegistrationStatusSelection,
    CourseSettingsToggles,
    CoursePackagesTab,
    DisableCourseModulesModal
  }
})
export default class EditCourseSettings extends Vue {
  isSettings: boolean = true;
  isAddingConfirmed: boolean = false;
  notify: boolean = false;
  existingEmailDomains: string[] = [];
  isMemberDataValid: boolean = true;
  allowedEmailDomains: string[] = [];
  removedEmailDomains: RemoveEmailDomainsPayload[] = [];
  removedMemberIds: number[] = [];
  initialDomains: string[] = [];
  currentActiveTab: number = 0;
  disableModulesTab: boolean = true;

  $style!: Record<string, string>;
  name = '';
  type: CourseTypeDTO | null = null;
  groupTypes: UserAttributesStringInputOption[] = [];
  userAttributes: MyjbiGroupUserAttributeSpec[] = [...defaultGULAs];
  agreementFiles: Array<
    File | Partial<GetSignedUrlForUploadResponsePayload>
  > = [];
  membersFile: File | null = null;
  membersData: MemberObject[] | null = null;
  isDownloading = false;
  selectedGroupLevelAttributes: GroupLevelAttributeValue[] | null = null;
  activeGroupAttributes: GroupLevelAttributeValue[] = [];
  deleteGroupAttributes: GroupLevelAttributeValue[] = [];
  courseLevelAttributeFormHasError: boolean = false;
  parentGroup: MasterGroupsResponseDTO | null = null;
  isCoursePublished: boolean = false;

  tabKey: number = Math.floor(Math.random() * 999);

  // Non-API related Course Module States and Actions
  @Action('courseModule/clearActiveCourseModules')
  clearActiveCourseModules!: () => void;

  @Action('course/storeSelectedCourseType')
  storeSelectedCourseType!: (payload?: CourseTypeOption) => void;

  @Action('admin/storeCurrentGroupName')
  storeCurrentGroupName!: (payload: string) => void;

  @Action('course/setCurrentActiveTab')
  setCurrentActiveTab!: (tabName: string) => void;

  @Action('courseModule/deleteCourseModuleApi')
  deleteCourseModuleApi!: (payload: DeleteCourseModulesApiDTO) => void;

  @Action('coursePackage/deleteCoursePackages')
  deleteCoursePackagesApi!: (payload: number[]) => void;

  @Action('coursePackage/upsertCoursePackages')
  upsertCoursePackages!: (payload: UpsertCoursePackageApiDTO) => void;

  @State(
    (state: RootState) =>
      state.courseModule.courseModulesTabState.activeCourseModules
  )
  activeCourseModules!: CourseModuleComponentItem[];

  @State(
    (state: RootState) =>
      state.coursePackage.coursePackageTabState.activeCoursePackages
  )
  activeCoursePackages!: CoursePackageComponent[];

  @State(
    (state: RootState) =>
      state.courseModule.courseModulesTabState.deletedCourseModules
  )
  deletedCourseModules!: CourseModuleComponentItem[];

  @State(
    (state: RootState) =>
      state.courseModule.courseModulesTabState.courseModuleFormHasError
  )
  courseModuleFormHasError!: boolean;

  @State(
    (state: RootState) =>
      state.coursePackage.coursePackageTabState.coursePackageFormHasError
  )
  coursePackageFormHasError!: boolean;

  @State((state: RootState) => state.course.courseCreationState.hasModules)
  hasModules!: boolean;

  @State(
    (state: RootState) => state.course.courseCreationState.hasQuestionnaire
  )
  hasQuestionnaire!: boolean;

  @State((state: RootState) => state.course.courseCreationState.isFreeCourse)
  isFreeCourse!: boolean;

  @State((state: RootState) => state.admin.currentGroupName)
  currentGroupName!: string;

  @State(
    (state: RootState) => state.course.courseCreationState.selectedCourseType
  )
  selectedCourseType!: CourseTypeOption;

  @State(
    (state: RootState) =>
      state.course.courseLicenseState.shouldCreateWithLicense
  )
  shouldCreateWithLicense!: boolean;

  @State((state: RootState) => state.course.courseTabState.activeTabName)
  activeTabName!: CourseTabsNames;

  // Uninitialised update payload
  localCourseStatusPayload: UpdateCourseStatusDTO | null = null;
  localCourseLicensePayload: CreateGroupLicenseDTO | null = null;
  courseModulePayload: UpsertCourseModuleDTO | null = null;

  // Course related variables
  visibility: CourseVisibility = CourseVisibility.PRIVATE;
  openForRegistration: boolean = false;
  requireRegistrationConfirmation: boolean = false;

  @Action('course/getCourseTypes')
  getCourseTypes!: () => Promise<CourseTypeDTO[]>;

  @State((state: RootState) => state.course.courseTypes)
  courseTypes!: CourseTypeDTO[];

  @State(({ course }: RootState) => course.apiState.getCourseTypes.success)
  getCourseTypesSuccess!: ApiState;

  @Action('trainer/getTrainers')
  getAllTrainers!: () => void;

  @State((state: RootState) => state.trainer.trainers)
  trainers!: TrainerResponseDTO[];

  @Action('admin/getGroupDetail')
  getGroupDetail!: (params: {
    id: number;
    isMembers: boolean;
  }) => Promise<GroupDetail>;

  @Action('course/getCourseDetails')
  getCourseDetails!: (courseId: number) => void;

  @Action('admin/updateGroup')
  updateGroup!: (payload: UpdateGroupRequestPayload) => Promise<void>;

  @Action('course/updateCourse')
  updateCourse!: (payload: UpdateCourseMasterDTO) => void;

  @Action('course/updateCourseTypes')
  updateCourseType!: (payload: UpdateCourseTypeApiDTO) => void;

  @Action('admin/deleteGroup')
  deleteGroup!: (id: number) => Promise<void>;

  @Action('admin/updateGroupLevelAttributeValues')
  updateGroupLevelAttributeValues!: (
    payload: UpdateGroupLevelAttributeValueDTO
  ) => Promise<void>;

  @Action('admin/updateGroupLevelAttributeValues')
  upsertIndividualGroupLevelAttributeValue!: (
    payload: UpdateIndividualGroupLevelAttributeValueDTO
  ) => Promise<void>;

  @Action('rolesAndPermissions/getGroupExceptions')
  getGroupExceptions!: (groupId: number) => Promise<ResourceExceptions>;

  @State(
    (state: RootState) => state.admin.apiState.updateGroupLevelAttributeValues
  )
  updateGroupLevelAttributeValuesApiState!: ApiState;

  @State((state: RootState) => state.rolesAndPermissions.groupExceptions)
  groupExceptions!: ResourceExceptions;

  @State((state: RootState) => state.admin.groupDetail)
  groupDetail!: GroupDetail;

  @State((state: RootState) => state.course.courseDetails)
  courseDetails!: CourseDetails;

  @State(({ course }: RootState) => course.apiState.updateCourse)
  updateCourseApiState!: ApiState;

  @State(({ course }: RootState) => course.apiState.getCourseDetails.success)
  getCourseDetailsSuccess!: boolean;

  @State(({ admin }: RootState) => admin.apiState.updateGroup.loading)
  updateGroupLoading!: boolean;

  @State(({ admin }: RootState) => admin.apiState.updateGroup)
  updateGroupApiState!: ApiState;

  @State(({ course }: RootState) => course.apiState.updateCourseType)
  updateCourseTypeApiState!: ApiState;

  @State(({ admin }: RootState) => admin.apiState.deleteGroup.loading)
  deleteGroupLoading!: boolean;

  @State(
    (state: RootState) => state.coursePackage.apiState.upsertCoursePackageApi
  )
  upsertCoursePackageApiState!: ApiState;

  @State(
    (state: RootState) => state.coursePackage.apiState.deleteCoursePackageApi
  )
  deleteCoursePackageApiState!: ApiState;

  @State(
    (state: RootState) => state.courseModule.apiState.createCourseModulesApi
  )
  createCourseModuleApiState!: ApiState;

  @State(
    (state: RootState) => state.courseModule.apiState.updateCourseModulesApi
  )
  updateCourseModuleApiState!: ApiState;

  @State(
    (state: RootState) => state.courseModule.apiState.deleteCourseModulesApi
  )
  deleteCourseModuleApiState!: ApiState;

  @State((state: RootState) => state.admin.groupLevelAttributeValuesByGroupId)
  groupLevelAttributeValuesByGroupId!: GroupLevelAttributeValue[];

  public isUserAllowed(
    action: PermissionsMatrixActionsEnum,
    module: string | string[],
    skipImplicitCheck?: boolean
  ): boolean {
    const instance = EntityTypes.GROUP + '_' + this.groupId;
    const groupTypeName = this.groupDetail
      ? this.groupDetail.types[0]
      : undefined;
    return this.isSettings
      ? isUserAllowed(
          action,
          module,
          EntityTypes.GROUP,
          groupTypeName,
          this.groupId,
          this.groupExceptions,
          skipImplicitCheck
        )
      : true;
  }

  get isLoading(): boolean {
    return (
      this.updateCourseApiState.loading ||
      this.updateCourseTypeApiState.loading ||
      this.updateGroupApiState.loading ||
      this.updateGroupLevelAttributeValuesApiState.loading ||
      this.upsertCoursePackageApiState.loading ||
      this.deleteCoursePackageApiState.loading ||
      this.createCourseModuleApiState.loading ||
      this.deleteCourseModuleApiState.loading ||
      this.updateCourseModuleApiState.loading
    );
  }

  get tabsConfigs(): TabComponent[] {
    return [
      { name: CourseTabsNames.ATTRIBUTES, visible: true },
      { name: CourseTabsNames.MODULES, visible: this.hasModules },
      { name: CourseTabsNames.PRICING, visible: !this.isFreeCourse },
      { name: CourseTabsNames.DISCOUNTS, visible: true },
      { name: CourseTabsNames.COMMUNICATION, visible: true },
      { name: CourseTabsNames.TASKS, visible: true },
      { name: CourseTabsNames.ATTENDANCE, visible: true },
      { name: CourseTabsNames.ATTACHMENTS, visible: true },
      // JAAS-2803-TODO:
      // Integrate with Course Registration Questions UX flow, simply enable/disable for now:
      // https://www.figma.com/proto/YfuvHV60ckzW6kSMddXYSv/JTMS---UI-Design--2025-?node-id=411-43659&viewport=139%2C209%2C0.04&t=L8GUGpUoiOCDdsvg-1&scaling=scale-down-width&content-scaling=fixed&starting-point-node-id=411%3A41950&show-proto-sidebar=1
      { name: CourseTabsNames.QUESTIONS, visible: this.hasQuestionnaire }
    ];
  }

  get visibleTabs(): TabComponent[] {
    return this.tabsConfigs.filter((tab) => tab.visible);
  }

  get hasDefaultCourseModule() {
    if (!this.activeCourseModules) {
      return false;
    }

    return this.activeCourseModules.some(
      (cm) => cm.status === CourseModuleStatus.DEFAULT
    );
  }

  get hasDefaultCoursePackage() {
    if (!this.activeCoursePackages) {
      return false;
    }

    return this.activeCoursePackages.some(
      (pkg) => pkg.status === CoursePackageStatus.DEFAULT
    );
  }

  get hasAccessToCourseLevelAttributes() {
    return (
      this.isUserAllowed(PermissionsMatrixActionsEnum.UPDATE, [
        'group_administration-groups-update_groups-update_group_attributes-update_title_and_logo',
        'group_administration-groups-update_groups-update_group_attributes-update_existing_attributes',
        'group_administration-groups-update_groups-update_group_attributes-create_group_attributes'
      ]) ||
      this.isUserAllowed(
        PermissionsMatrixActionsEnum.READ,
        'group_administration-groups-update_groups-update_group_attributes-read_existing_group_templates'
      )
    );
  }

  get courseId() {
    return +this.$route.params.courseId;
  }

  get permissionMatrixActionsEnum() {
    return PermissionsMatrixActionsEnum;
  }

  get CourseTabsNames() {
    return CourseTabsNames;
  }

  get hasCourseModules() {
    return this.courseDetails.courseModules.length > 0;
  }

  get groupId() {
    return this.courseDetails.relatedJAASGroupId;
  }

  get pageIsLoading(): boolean {
    return !this.groupDetail || this.deleteGroupLoading;
  }

  get isPublished() {
    return this.courseDetails.status === 'PUBLISHED';
  }

  get courseTypeOptions(): CourseTypeOption[] {
    if (!this.courseTypes) {
      return [];
    }
    return Object.values(this.courseTypes).map((courseType: CourseTypeDTO) => ({
      id: courseType.id,
      name: courseType.name
    }));
  }

  mounted() {
    if (!this.courseDetails || this.courseDetails.id !== this.courseId) {
      this.getCourseDetails(this.courseId);
    }
    this.getCourseTypes();

    if (this.selectedCourseType) {
      this.type = {
        id: this.selectedCourseType.id!,
        name: this.selectedCourseType.name
      };
    }

    if (!this.trainers) {
      this.getAllTrainers();
    }
  }

  handleRedirect() {
    // this.$router.replace(`/admin/jtms/courses/view-course/${this.courseId}`);
    this.$router.replace({
      name: 'view-courses',
      params: {
        courseId: this.courseId.toString(),
        fromSettings: 'true',
        shouldRefetchDetails: 'true'
      }
    });
  }

  assignParentGroup(data: MasterGroupsResponseDTO) {
    this.parentGroup = data;
  }

  courseSettingsHasError(
    isValidationObserverInvalid: boolean,
    isValidationObserverValidated: boolean
  ): boolean {
    return (
      isValidationObserverInvalid ||
      this.courseLevelAttributeFormHasError ||
      this.courseModuleFormHasError ||
      (!this.isFreeCourse && this.coursePackageFormHasError)
    );
  }

  constructUpsertPayload(attributeToUpdate: AttributeOptionsWithValue) {
    const upsertGroupLevelAttributeValuePayload: UpdateIndividualGroupLevelAttributeValueDTO = {
      groupId: this.groupId,
      attribute: attributeToUpdate
    };
    return upsertGroupLevelAttributeValuePayload;
  }

  handleUpdateCourseLevelAttributeValues(
    activeValues: GroupLevelAttributeValue[],
    error: boolean
  ) {
    this.activeGroupAttributes = activeValues;
    this.courseLevelAttributeFormHasError = error;
  }

  async handleUpdateGroup(eventType: CourseCreateAndUpdateButtonEventTypes) {
    switch (eventType) {
      case CourseCreateAndUpdateButtonEventTypes.CREATE_AND_PUBLISH:
        this.openPublishDraftCourseModal();
        break;
      case CourseCreateAndUpdateButtonEventTypes.PUBLISH_SAVE_WITH_REGISTRATION_CHANGES:
        this.openOrCloseRegistrationModal();
        this.handleRedirect();
        break;
      case CourseCreateAndUpdateButtonEventTypes.SAVE_SETTINGS:
        this.submitPayload();
        this.handleRedirect();
        break;
      default:
        break;
    }
  }

  constructAndSubmitPayload() {
    this.constructCourseStatusPayload();
    this.submitPayload();
  }

  /**
   * Constructs the course status payload.
   *
   * The reason for this separation is to match requirements in tech design.
   *
   * During course settings, a DRAFT course can be saved/updated without any
   * changes to the publication status. Therefore `courseStatusPayload` will
   * not be constructed (passed as undefined into backend) which then skips
   * updates on publication status.
   *
   * On the other hand, PUBLISHED courses will ALWAYS be updated with course
   * status, hence payload will always be constructed.
   */
  constructCourseStatusPayload() {
    const payload: UpdateCourseStatusDTO = {
      status: this.courseDetails.status,
      visibility: this.visibility,
      openForRegistration: this.openForRegistration,
      requireRegistrationConfirmation: this.requireRegistrationConfirmation,
      isFreeCourse: this.isFreeCourse,
      hasQuestionnaire: this.hasQuestionnaire,
      groupRegistration: this.courseDetails.groupRegistration
    };

    this.localCourseStatusPayload = payload;
  }

  constructCourseModulePayload() {
    if (!this.hasModules) {
      return;
    }

    const payload: UpsertCourseModuleDTO = {
      moduleComponents: {
        active: convertCourseModuleComponentItem(this.activeCourseModules),
        deleted: convertCourseModuleComponentItem(
          this.deletedCourseModules,
          true
        )
      }
    };

    this.courseModulePayload = payload;
  }

  openPublishDraftCourseModal() {
    this.$buefy.modal.open({
      parent: this,
      component: PublishDraftCourseModal,
      hasModalCard: true, // added to prevent breaking on mobile
      trapFocus: true,
      fullScreen: false,
      canCancel: true,
      props: {
        visibility: this.courseDetails.visibility,
        openForRegistration: this.courseDetails.openForRegistration,
        requireRegistrationConfirmation:
          this.courseDetails.status === CourseStatus.DRAFT
            ? true
            : this.courseDetails.requireRegistrationConfirmation,
        groupRegistration: this.courseDetails.groupRegistration,
        enableQuestionnaire: this.hasQuestionnaire,
        freeCourse: this.isFreeCourse,
        isSettings: this.isSettings,
        groupDetails: this.groupDetail,
        attributes: deepCopy(this.groupLevelAttributeValuesByGroupId),
        courseStatus: this.courseDetails.status
      },
      events: {
        // Replace with update payload
        publishDraftCourse: (
          updateCourseStatusPayload: UpdateCourseStatusDTO,
          createLicensePayload?: CreateGroupLicenseDTO
        ) => {
          this.localCourseStatusPayload = updateCourseStatusPayload;

          if (createLicensePayload) {
            const payloadWithGroupId = {
              ...createLicensePayload,
              groupId: this.groupId
            };

            this.localCourseLicensePayload = payloadWithGroupId;
          }

          this.publishCourse();

          Toast.open({
            queue: true,
            type: 'is-dark',
            position: 'is-top',
            message: `Course successfully published`
          });
          this.handleRedirect();
        }
      }
    });
  }

  openOrCloseRegistrationModal(): void {
    this.$buefy.modal.open({
      parent: this,
      component: OpenOrCloseRegistrationModal,
      hasModalCard: true,
      trapFocus: true,
      props: {
        openForRegistration: this.openForRegistration
      },
      events: {
        emitToParent: () => {
          this.constructAndSubmitPayload();
        }
      }
    });
  }

  getUserAttributeArrayWithValue(): GroupUserAttributeWithValue[][] {
    return this.membersData && this.userAttributes
      ? userAttributesArrWithValues(this.membersData, this.userAttributes)
      : [];
  }

  getUpdateGroupPayload() {
    return {
      groupId: this.groupDetail.id,
      name: this.name,
      attributesSpecs: this.userAttributes,
      agreements: this.agreementFiles.map((f) => ({
        fileUri: (f as GetSignedUrlForUploadResponsePayload).storageUri,
        fileName: (f as GetSignedUrlForUploadResponsePayload).fileName
      })),
      userAttributesArr: this.getUserAttributeArrayWithValue(),
      parentPath: this.groupDetail?.path,
      types: this.groupTypes.map((t) => t.slug as MyjbiGroupType),
      emailDomains: this.allowedEmailDomains,
      removedEmailDomains:
        this.existingEmailDomains.length &&
        this.removedEmailDomains.length === this.existingEmailDomains.length
          ? [{ tag: null, notify: false }]
          : this.removedEmailDomains,
      emailDomainsNotify: this.notify,
      removedMemberIds: this.removedMemberIds
    };
  }

  getGLAPayload() {
    return {
      groupId: this.groupId,
      attributeValues: {
        active: convertToAttributeOptionsWithValue(
          this.groupLevelAttributeValuesByGroupId
        ),
        deleted: convertToAttributeOptionsWithValue(this.deleteGroupAttributes)
      }
    };
  }

  getUpdateCourseTypePayload(): UpdateCourseTypeApiDTO {
    return {
      courseId: this.courseId,
      courseTypeId: this.type?.id!
    };
  }

  async submitPayload() {
    const rootValidationObserver = this.$refs
      .rootValidationObserver as ValidationObserverInstance;
    if ((await rootValidationObserver.validate()) === false) {
      const message = !this.name?.trim()
        ? 'Name is required'
        : 'Please fill in all the required fields';
      return DialogProgrammatic.alert({
        title: `Error`,
        message: `<p class="subtitle">${message}<p>`,
        type: 'is-primary'
      });
    }

    try {
      // Group related updates
      const isGroupNameChanged: boolean = this.name !== this.currentGroupName;

      const groupPayload: UpdateGroupDTO = this.getUpdateGroupPayload();
      const GLAPayload: UpdateGroupLevelAttributeValueDTO = this.getGLAPayload();
      this.constructCourseModulePayload();
      this.constructCourseStatusPayload();

      const masterPayload: UpdateCourseMasterDTO & { courseId: number } = {
        courseId: this.courseDetails.id,
        updateGroupPayload: isGroupNameChanged ? groupPayload : undefined,
        updateGLAPayload: GLAPayload,
        updateCourseModulesPayload: this.courseModulePayload!,
        updateCourseStatusPayload: this.localCourseStatusPayload ?? undefined
      };

      this.updateCourse(masterPayload);
      // Account for course type changes
      // TODO: Move this into unified master payload for the updateCourse API
      this.onTypeSelected();
    } catch (error: any) {
      Toast.open({
        queue: true,
        type: 'is-danger',
        position: 'is-top',
        message: String(error?.response?.data?.message || error),
        duration: 5000
      });
    }
  }

  publishCourse() {
    try {
      const GLAPayload: UpdateGroupLevelAttributeValueDTO = this.getGLAPayload();
      const masterPayload: UpdateCourseMasterDTO & { courseId: number } = {
        courseId: this.courseDetails.id,
        updateGLAPayload: GLAPayload,
        updateCourseStatusPayload: this.localCourseStatusPayload ?? undefined,
        createCourseLicensePayload: this.localCourseLicensePayload ?? undefined
      };

      this.updateCourse(masterPayload);
    } catch (error: any) {
      Toast.open({
        queue: true,
        type: 'is-danger',
        position: 'is-top',
        message: String(error?.response?.data?.message || error),
        duration: 5000
      });
    }
  }

  handleCourseModuleDeletion() {
    const courseModuleIdsToDelete: number[] = this.activeCourseModules.map(
      (cm) => cm.id!
    );

    this.deleteCourseModuleApi({
      courseId: this.courseId,
      courseModuleIdsToDelete
    });
  }

  handleCoursePackageDeletion() {
    const coursePackgeIdsToDelete: number[] = this.activeCoursePackages.map(
      (pkg) => pkg.id!
    );

    // Guard for prevent deleting temporary packages with negative ID
    if (!coursePackgeIdsToDelete.some((id) => id * -1 > 0)) {
      this.deleteCoursePackagesApi(coursePackgeIdsToDelete);
    }
  }

  // Deletion sequence & await is important here; course packages first, THEN course modules
  // Else backend will throw not found error on course modules
  async handleCourseModuleAndPackageDeletion() {
    await this.handleCoursePackageDeletion();
    await this.handleCourseModuleDeletion();
  }

  handleRedirectFromSettings() {
    this.$router.push({
      name: 'view-courses',
      params: {
        courseId: this.courseId.toString(),
        fromSettings: 'true',
        shouldRefetchDetails: 'true'
      }
    });
  }

  saveNameChanges() {
    const nameChanged: boolean = this.name !== this.currentGroupName;

    if (nameChanged) {
      this.updateGroup(this.getUpdateGroupPayload());
      this.storeCurrentGroupName(this.name);
    }
  }

  @Watch('name')
  @Debounce(2000)
  onNameChanged() {
    this.saveNameChanges();
  }

  @Watch('type')
  @Debounce(2000)
  onTypeSelected() {
    const typeChanged: boolean =
      this.type?.name !== this.selectedCourseType.name;

    if (typeChanged) {
      this.updateCourseType(this.getUpdateCourseTypePayload());
      this.storeSelectedCourseType(this.type!);
    }
  }

  @Watch('currentActiveTab')
  onTabClick(newIndex: number): void {
    const newActiveTab = this.visibleTabs[newIndex];
    // Update the Vuex store only if the name is different, to prevent infinite loops.
    if (newActiveTab && newActiveTab.name !== this.activeTabName) {
      this.setCurrentActiveTab(newActiveTab.name);
    }
  }

  @Watch('updateCourseTypeApiState')
  @Watch('updateGroupApiState')
  onUpdateNameOrTypeApiStateChanged(state: ApiState) {
    if (state.success) {
      Toast.open({
        type: 'is-success',
        position: 'is-top',
        message: 'Changes saved.',
        duration: 2000,
        queue: false
      });
    }

    if (state.error) {
      Toast.open({
        queue: true,
        type: 'is-danger',
        position: 'is-top',
        message: 'Something went wrong. Could not update course name.'
      });
    }
  }

  @isTruthy
  @Watch('getCourseDetailsSuccess')
  onGetCourseDetailsSuccess() {
    this.getGroupDetail({ id: this.groupId, isMembers: false });
    this.getGroupExceptions(this.groupId);
  }

  @isTruthy
  @Watch('groupDetail', { immediate: true })
  onGroupLoaded() {
    this.allowedEmailDomains = this.groupDetail?.emailDomains || [];
    this.existingEmailDomains = this.groupDetail?.emailDomains || [];
    this.initialDomains = this.allowedEmailDomains
      ? [...this.allowedEmailDomains]
      : [];
    this.name = this.groupDetail!.name;
    this.groupTypes =
      this.groupDetail?.types.map((t) => ({ slug: t, name: t })) || [];
    this.userAttributes = this.groupDetail?.groupUserAttributeSpecs
      ? this.groupDetail?.groupUserAttributeSpecs
      : [];
    this.agreementFiles = this.groupDetail!.agreements.map(
      (a) =>
        ({
          storageUrl: a.fileUrl,
          storageUri: a.fileUri,
          fileName: a.fileName
        } as Partial<GetSignedUrlForUploadResponsePayload>)
    );
    this.membersFile = null;
  }

  @isTruthy
  @Watch('courseDetails')
  onCourseDetailsLoaded() {
    this.type = {
      id: this.courseDetails.courseType.id!,
      name: this.courseDetails.courseType.name
    };
    this.isCoursePublished =
      this.courseDetails.status === CourseStatus.PUBLISHED;

    // Load existing values into local variables
    this.visibility = this.courseDetails.visibility;
    this.openForRegistration = this.courseDetails.openForRegistration;
    this.requireRegistrationConfirmation = this.courseDetails.requireRegistrationConfirmation;
  }

  @Watch('updateCourseApiState', { deep: true })
  onCourseUpdateApiStateChange(state: ApiState) {
    if (state.success) {
      // Reset all update sub-payloads
      this.localCourseStatusPayload = null;
      this.courseModulePayload = null;
      this.deleteGroupAttributes = [];
      // this.handleRedirectFromSettings();
    }

    if (state.error) {
      Toast.open({
        queue: true,
        type: 'is-danger',
        position: 'is-top',
        message: String(
          (state.error as ApiAxiosError)?.response?.data?.message ?? state.error
        )
      });
    }
  }

  @Watch('shouldCreateWithLicense', { immediate: true })
  onDisabledCourseLicenseCreation() {
    // Ensure local course license payload is reset
    if (!this.shouldCreateWithLicense) {
      this.localCourseLicensePayload = null;
    }
  }

  @Watch('isFreeCourse', { immediate: true })
  onToggleFreeCourse() {
    if (this.isFreeCourse && this.activeTabName === CourseTabsNames.PRICING) {
      this.currentActiveTab = 0;
    }

    if (
      this.isSettings &&
      this.activeCoursePackages.length > 0 &&
      !this.hasDefaultCoursePackage
    ) {
      if (this.isFreeCourse) {
        this.activeCoursePackages.forEach((pkg) => {
          if (pkg.id && pkg.id > 0) {
            const payload: UpsertCoursePackageApiDTO = {
              courseId: this.courseDetails.id,
              coursePackageId: pkg.id,
              courseModulesIds: pkg.courseModules.map((m) => m.id!),
              amount: 0,
              currency: pkg.currency
            };
            this.upsertCoursePackages(payload);
          }
        });
      }

      this.constructCourseStatusPayload();
      const masterPayload: UpdateCourseMasterDTO & { courseId: number } = {
        courseId: this.courseDetails.id,
        updateCourseStatusPayload: this.localCourseStatusPayload ?? undefined
      };

      this.updateCourse(masterPayload);
    }
  }

  @Watch('hasModules', { immediate: true })
  onDisableModuleTab() {
    if (!this.hasModules) {
      if (!this.isSettings) {
        this.clearActiveCourseModules();
      }

      // Remove existing course modules only if they arent default
      if (
        this.isSettings &&
        this.activeCourseModules.length > 0 &&
        !this.hasDefaultCourseModule
      ) {
        this.handleCourseModuleAndPackageDeletion();
        this.clearActiveCourseModules();
      }

      // Ensure payload is reset
      this.courseModulePayload = null;

      // Handle redirection to 1st tab if user was on "Modules" tab
      if (this.currentActiveTab === 1) {
        this.currentActiveTab = 0;
      }
    }
  }
}
